const config = {
  isDev: process.env.NODE_ENV === 'development',
  baseUrl: 'https://xyxzapi.huishoubao.com',
  hsbproUrl: 'https://hsbpro.huishoubao.com',
  defaultDomain: 'https://xyxzapi.huishoubao.com',
  defaultPath: '/api/xianyu',
  reportURL: 'https://logreport.huishoubao.com/hjxapps/', // 上报地址
  appusetype: '1',
  pid: 1426, // 闲鱼小站app pid
  channelId: 10000180 // 闲鱼小站渠道id
};
export default config;
